<template>
  <article class="classes" v-if="charged">
    <section class="trainers__header">
      <div class="trainers__header--title">
        <p style="width:100%">Editar {{offer.attributes.title}}</p>
        <v-breadcrumbs style="width: 100%">
          <v-icon slot="divider">chevron_right</v-icon>
          <v-breadcrumbs-item
            @click="$router.push({name: 'classes_classes'})">
            Listado de clases
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            disabled>
            {{offer.attributes.title}}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </div>
    </section>
    <section class="trainers__create_container">
      <v-layout row wrap>
        <v-flex xs6>
          <!-- Fotos de la oferta -->
          <span class="data_card__info--label">Imagen</span>
          <div class="trainers__form--photo_container">
            <label
              for="trainerPhoto"
              style="
              width: 160px;
              height: 34px;"
              class="trainers__form--photo_button">Examinar</label>
            <input
              id="trainerPhoto"
              type="file"
              @change="onFileChange"
              name="logo"
              multiple>
            <p v-if="!url_change">{{ photo_name }}</p>
          </div>
          <v-flex
            xs12
            v-if="url_change"
            class="classes__image_container">
            <div
              v-for="(image, index) in offer_photos"
              class="classes__image_container--image"
              :style="{backgroundImage: 'url('+ (image.id ? getImageServer() + image.image : image.url_image) +')'}">
              <div
                class="data_card__info--remove"
                @click="deleteImage(index)">
                <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Título</span>
            <input
              class="trainers__form--input"
              type="text"
              name="Title"
              placeholder="Título de la clase"
              v-model="offer.attributes.title">
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Descripción</span>
            <input
              class="trainers__form--input"
              type="text"
              name="Name"
              placeholder="Descripción"
              v-model="offer.attributes.description">
          </v-flex>
          <v-flex xs12>
            <span class="data_card__info--label">Términos y condiciones</span>
            <input
              class="trainers__form--input"
              type="text"
              name="TyC"
              placeholder="Términos y condiciones generales de la clase"
              v-model="offer.attributes.tc">
          </v-flex>
          <!-- <v-flex xs12>
            <span class="data_card__info--label">Fecha de vencimiento</span>
            <app-single-date-picker
              :date_text="offer.attributes.expiration"
              @filterQuery="changeDate($event)"></app-single-date-picker>
          </v-flex> -->
          <v-flex xs12>
            <span class="data_card__info--label">Entrenadores</span>
            <div
              class="dashboard__options--input with_box_shadow"
              style="width: 100%; margin-bottom: 20px;"
              @click="show_trainers_modal = true">
              <p >{{trainers_text}}</p>
              <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg">
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="data_card__counter data_card__counter--center_align">
              <p>Canjes por usuario: </p>
              <input
                class="data_card__counter--number_input"
                type="number"
                name="limit_per_user"
                placeholder=""
                v-model="offer.attributes.redeem_limit_per_user"
                min="0">
              <div
                class="data_card__counter--button"
                @click="removeFromRedemption()"></div>
              <div
                class="data_card__counter--button"
                @click="addToRedemption()"></div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="data_card__counter data_card__counter--center_align">
              <p>Limite de dias para canjear las clases: </p>
              <input
                class="data_card__counter--number_input"
                type="number"
                name="limit_days"
                v-model="offer.attributes.limit_days"
                min="0">
              <div
                class="data_card__counter--button"
                @click="removeFromLimitDays()"></div>
              <div
                class="data_card__counter--button"
                @click="addToLimitDays()"></div>
            </div>
          </v-flex>
          <!-- <v-flex xs12>
            <v-switch
              class="data_card__switch"
              :label="`Hacer visible`"
              v-model="offer.attributes.published"
            ></v-switch>
          </v-flex> -->
        </v-flex>
        <v-flex xs6 >
          <v-flex xs11 offset-xs1>
            <section class="data_card data_card__instance">
              <div
                class="data_card__image"
                :class = "{'without_url' : !url_change}"
                :style="{backgroundImage: 'url('+ current_image_url +')'}"></div>
              <div class="data_card__info">
                <div class="data_card__info--container">
                  <p class="data_card__info--title">
                    {{offer.attributes.title}}
                  </p>
                </div>
                <!-- <div class="data_card__info--container">
                  <p class="data_card__info--text expiration">
                    {{ offer.attributes.expiration != '' ? `Hasta ${offer.attributes.expiration}` : ''}}
                  </p>
                </div> -->
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Descripción</span>
                  <p class="data_card__info--text full_text">
                    {{offer.attributes.description}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Términos y condiciones</span>
                  <p class="data_card__info--text full_text">
                    {{offer.attributes.tc}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Numero de clases</span>
                  <p class="data_card__info--text classes_quantity">
                    {{Number(offer.attributes.redeem_limit_per_user) > 0 ? offer.attributes.redeem_limit_per_user : ''}}
                  </p>
                </div>
                <div class="data_card__info--container">
                  <span class="data_card__info--label">Entrenadores</span>
                  <section class="data_card__info--trainers_container">
                    <div
                      class="data_card__info--trainer default_trainer"
                      v-if="selected_trainers.length <= 0">
                    </div>
                    <div
                      class="data_card__info--trainer"
                      v-else
                      v-for="(trainer, index) in selected_trainers"
                      :style="{backgroundImage: `url('${getImageServer() + trainer.attributes.image.thumb.url}')`}">
                      <div
                        class="data_card__info--remove"
                        @click="deleteLocation(index)">
                        <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </section>
            <div
              class="data_card__create_button"
              @click="checkForm()">
              Guardar
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </section>
    <trainers-modal
      v-if="show_trainers_modal"
      :trainers="locations"
      :selected="selected_trainers"
      @closeTrainersModal="closeTrainersModal($event)"
      @saveTrainers="filterSelectedTrainers($event)"></trainers-modal>
  </article>
</template>

<script>
export default {
  data(){
    return{
      current_image_url: 'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      offer: '',
      urls: [],
      locations:[],
      images: [],
      charged: false,
      offer_photos: [],
      tags_selected: [],
      parent_category:null,
      locations_selected:[],
      current_locations: [],
      conditions: [],
      condition_selected: '',
      url_change: false,
      photo_name: "No se han seleccionado archivos",
      trainers_text: 'Selecciona los entrenadores',
      show_trainers_modal: false,
      selected_trainers: [],
      reward_attributes:{
        condition_id: null,
        from: '',
        until:''
      },
    }
  },
  mounted(){
    // this.updateLocations([])
    // cl locations
    var path = this.$route.path.split('/')
    try {
      this.$http.get('classes/index_trainers',
      {headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}})
      .then(function(response){
        this.locations = response.body.data;
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      }, function(response){
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      })
    } catch (e) {
      alert(e.message)
    }
    try {
      this.$http.get('offers/'+ path[2],)
      .then(function(response){
        this.offer = response.body.data
        this.offer.offer_photos_attributes = []
        for (var i = 0; i < response.body.included.length; i++) {
          if(response.body.included[i].type == "offer_photos"){
            this.images.push(response.body.included[i])
            this.offer_photos.push({id: response.body.included[i].id, image: response.body.included[i].attributes.image.url})
          }else if(response.body.included[i].type == "locations"){
            let current_location = response.body.included[i]
            this.selected_trainers.push(current_location)
            this.current_locations.push(current_location)
          }
        }
        if(this.offer_photos.length > 0){
          this.current_image_url = this.getImageServer() + this.offer_photos[0].image
          this.url_change = true
        }
        // this.current_image_url = this.getImageServer() + this.offer_photos[0].image
        this.offer.location_offers_attributes = []
        // cl locations_selected
        // cl current_locations
        var reward_attributes = {
          condition_id: null,
          from: '',
          until:''
        }
        this.$set(this.offer, 'reward_attributes', reward_attributes)
        // cl offer
        this.charged = true
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      for (var i = 0; i < files.length; i++) {
        // this.offer.offer_photo_attributes.push({id: null, url_image: URL.createObjectURL(files[i])});
        this.createImage(files[i])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.offer_photos.push({url_image: URL.createObjectURL(file), image: reader.result, _destroy: ''})
        vm.current_image_url = vm.offer_photos[0].id ? vm.getImageServer() + vm.offer_photos[0].image : vm.offer_photos[0].url_image
        // cl offer_photos
      }
    },

    deleteImage(index){
      // for (var i = 0; i < this.offer.offer_photo_attributes.length; i++) {
      //   if (this.urls[index].id != null && this.images[i].id == this.urls[index].id) {
      //     this.offer.offer_photo_attributes.push({id: this.images[i].id, _destroy: true})
      //   }
      // }
      if(this.offer_photos[index].id != undefined && this.offer_photos[index].id != null){
        this.offer_photos[index]._destroy = this.offer_photos[index].id
        this.offer.offer_photos_attributes.push({id: this.offer_photos[index].id, _destroy: this.offer_photos[index]._destroy})
      }
      this.offer_photos.splice(index, 1)
    },
    deleteLocation(index){
      if(this.selected_trainers[index] != undefined && this.selected_trainers[index].id != null){

        for (var i = 0; i < this.offer.attributes.location_offers.length; i++) {
          if(this.offer.attributes.location_offers[i].location_id == this.selected_trainers[index].id){
            this.offer.location_offers_attributes.push({id: this.offer.attributes.location_offers[i].id, _destroy: this.offer.attributes.location_offers[i].id})
          }
        }
        // this.locations_selected[index]._destroy = this.locations_selected[index].id

      }
      // this.current_locations.splice(index, 1)
      this.selected_trainers.splice(index, 1)
    },
    scanForNews(){
      // cl selected_trainers
      for (var i = 0; i < this.selected_trainers.length; i++) {
        var found = false;
        var j=0;
        var a = ""
        while (!found && j < this.current_locations.length){
          if(this.selected_trainers[i].id==this.current_locations[j].id){
            found=true;
            a=this.selected_trainers[i].id
          }
          j++;
        }
        if(!found){
          this.offer.location_offers_attributes.push({location_id: this.selected_trainers[i].id})
        }
      }
    },
    scanForDeleteds(){
      for (var i = 0; i < this.current_locations.length; i++) {
        var found = false;
        var j=0;
        var a = ""
        while (!found && j < this.selected_trainers.length){
          if(this.current_locations[i].id==this.selected_trainers[j].id){
            found=true;
          }
          j++;
        }
        if(!found){
          for (var j = 0; j < this.offer.attributes.location_offers.length; j++) {
            if(this.offer.attributes.location_offers[j].location_id == this.current_locations[i].id){
              this.offer.location_offers_attributes.push({id: this.offer.attributes.location_offers[j].id, _destroy: this.offer.attributes.location_offers[j].id})
            }
          }
        }
      }
    },
    checkForm() {
      for (var i = 0; i < this.offer_photos.length; i++) {
        if(this.offer_photos[i].id == null){
          // this.offer.offer_photo_attributes.push(this.offer_photos[i])
          this.offer.offer_photos_attributes.push({image: this.offer_photos[i].image})
        }
      }
      this.scanForNews()
      this.scanForDeleteds()
      this.$delete(this.offer, 'links')
      this.$delete(this.offer, 'relationships')
      this.$delete(this.offer, 'type')
      this.$delete(this.offer, 'reward_attributes')
      // cl offer
      try {
        this.$http.patch('offers/'+ this.offer.id, {data: this.encrypt(this.offer).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          if (this.offer.attributes.is_class) {
            this.$router.push({name: 'classes_classes'})
          }else{
            this.$router.push({name: 'offer'})
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    changeDate(val){
      // cl val
      this.offer.attributes.expiration = val
    },
    closeTrainersModal(val){
      this.show_trainers_modal = val
    },
    filterSelectedTrainers(val){
      // cl val
      this.selected_trainers = val
      this.trainers_text = val.length > 1 ? `${val.length} seleccionados` : `${val.length} seleccionado`
      this.show_trainers_modal = false;
    },
    addToRedemption(){
      this.offer.attributes.redeem_limit_per_user = Number(this.offer.attributes.redeem_limit_per_user) + 1
    },
    removeFromRedemption(){
      if(Number(this.offer.attributes.redeem_limit_per_user) > 0){
        this.offer.attributes.redeem_limit_per_user = Number(this.offer.attributes.redeem_limit_per_user) - 1
      }
    },
    addToLimitDays(){
      this.offer.attributes.limit_days = Number(this.offer.attributes.limit_days) + 1
    },
    removeFromLimitDays(){
      if(Number(this.offer.attributes.limit_days) > 0){
        this.offer.attributes.limit_days = Number(this.offer.attributes.limit_days) - 1
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/classes/Edit_class.vue